import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '~/app/store';
import useDelayedResult from '~/common/hooks/useDelayedResult';
import { BDRequestStatus } from '~/common/models/apis/apiResponse.model';
import { getAllowedContexts } from '~/store/profile/profileSlice';
import {
  allowedContextOperationSelector,
  selectActingPermissionsContextIds,
  selectAllowedContexts,
} from '~/store/profile/profileSlice.selectors';

export const useAllowedContexts = () => {
  const dispatch = useAppDispatch();
  const actingPermissionsContextIds = useSelector(
    selectActingPermissionsContextIds
  );
  const {
    result: allowedContexts,
    isLoading,
    isFailed,
  } = useDelayedResult(selectAllowedContexts, allowedContextOperationSelector);
  const operationStatus = useSelector(allowedContextOperationSelector);
  const canFetchAllowedContexts =
    !!actingPermissionsContextIds?.organizationsId;
  useEffect(() => {
    const { organizationsId, fleetsId } = actingPermissionsContextIds || {};

    if (!organizationsId) {
      return;
    }
    // Check if data already exists for this organization
    const hasExistingData = !!allowedContexts?.[organizationsId];

    // Check if request is already in progress or completed successfully
    const isRequestInProgress =
      operationStatus.status === BDRequestStatus.PENDING ||
      (operationStatus.status === BDRequestStatus.SUCCEEDED && hasExistingData);

    // Only dispatch if data doesn't exist and request isn't already in progress
    if (!hasExistingData && !isRequestInProgress) {
      dispatch(getAllowedContexts({ organizationsId, fleetsId }));
    }
  }, [
    dispatch,
    actingPermissionsContextIds,
    allowedContexts,
    operationStatus.status,
  ]);
  return { allowedContexts, canFetchAllowedContexts, isLoading, isFailed };
};
